import { memo } from 'react'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/shared/components/ui/alert-dialog"
import { Loader2 } from "lucide-react"

interface RegenerateConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  isRegenerating: boolean
  onConfirm: () => void
}

interface DeleteConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  isDeleting: boolean
  onConfirm: () => void
}

export const RegenerateConfirmDialog = memo(({
  open,
  onOpenChange,
  isRegenerating,
  onConfirm
}: RegenerateConfirmDialogProps) => {
  
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>确认重新生成 API Key？</AlertDialogTitle>
          <AlertDialogDescription>
            重新生成后，<span className="font-semibold text-destructive">旧的 API Key 将立即失效</span>。
            使用旧 Key 的外部系统将无法继续调用。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isRegenerating}>取消</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm} 
            disabled={isRegenerating}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isRegenerating ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                生成中...
              </>
            ) : (
              '确认重新生成'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
})

RegenerateConfirmDialog.displayName = 'RegenerateConfirmDialog'

export const DeleteConfirmDialog = memo(({
  open,
  onOpenChange,
  isDeleting,
  onConfirm
}: DeleteConfirmDialogProps) => {
  
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>确认删除 API Key？</AlertDialogTitle>
          <AlertDialogDescription>
            删除后，<span className="font-semibold text-destructive">所有使用此 Key 的外部系统将立即无法调用</span>。
            此操作不可恢复。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>取消</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm} 
            disabled={isDeleting}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                删除中...
              </>
            ) : (
              '确认删除'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
})

DeleteConfirmDialog.displayName = 'DeleteConfirmDialog'